import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["label", "errorMessage", "required"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import * as React from 'react';
import { clsx as cx } from 'clsx';
import { Input } from '../../../input';
import styles from './styles.module.css';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var FormFieldInputComponent = /*#__PURE__*/React.forwardRef(function FormField(props, ref) {
  var label = props.label,
    errorMessage = props.errorMessage,
    required = props.required,
    inputProps = _objectWithoutProperties(props, _excluded);
  var labelClasses = cx(styles['label'], _defineProperty({}, styles['required'], required));
  return /*#__PURE__*/_jsxs("div", {
    ref: ref,
    children: [label && /*#__PURE__*/_jsx("label", {
      className: labelClasses,
      children: label
    }), /*#__PURE__*/_jsx(Input, _objectSpread({}, inputProps)), errorMessage && /*#__PURE__*/_jsx("div", {
      className: styles['error_message'],
      children: errorMessage
    })]
  });
});
FormFieldInputComponent.defaultProps = {
  required: false
};

/**
 * DEPRECATED
 *
 * Используйте простой FromField
 */
export var FormFieldInput = /*#__PURE__*/React.memo(FormFieldInputComponent);